import { UserCircle } from 'lucide-react';

import type { RouteListItem } from '@/types';

import { settingsBcLink } from '../model';

export const subNav: RouteListItem[] = [
  {
    path: '/settings/job-positions/$id',
    name: 'Job Position',
    icon: UserCircle,
    show: true,
  },
  { path: '/settings/job-positions/$id/agreement', name: 'Position Agreement', icon: UserCircle, show: true },
  {
    path: '/settings/job-positions/$id/advertisement',
    name: 'Job Listing & Advertisement',
    icon: UserCircle,
    show: true,
  },
  { path: '/settings/job-positions/$id/hiring', name: 'Hiring', icon: UserCircle, show: true },
];

export const breadcrumbsLinks: RouteListItem[] = [
  settingsBcLink,
  { path: '/settings/job-positions', name: 'Job Positions' },
];
